import { Row, Col, Modal, Form, Input, Tabs, Badge } from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import languages from "../../config/language";
import { MAKE_URL } from "../../constants/conts";
import VehicleManufacturerSelect from "../../components/select/VehicleManufacturerSelect";
import VehicleSelect from "../../components/select/VehicleSelect";
const { TabPane } = Tabs;

const From = ({ path, sectionName, show, hide, data, refresh }) => {

  const [form]                  =   Form.useForm();
  const { request }             =   useRequest();
  const [loading, setLoading]   =   useState(false);
  const [manufacturerId, setManufacturerId]     =   useState(null);
  const [validationStatus, setValidationStatus] = useState({ name: {}, display_name: {} });

  useEffect(() => {
    const initialNameStatus = {};
    const initialDisplayStatus = {};
    
    languages.forEach(lang => {
      initialNameStatus[lang.short] = data ? !!data[`${lang.short}_name`] : false;
      initialDisplayStatus[lang.short] = data ? !!data[`${lang.short}_display_name`] : false;
    });
    
    setValidationStatus({
      name: initialNameStatus,
      display_name: initialDisplayStatus,
    });

    if (data) {
      form.setFieldsValue({ ...data });
      setManufacturerId(data.manufacturer_id?._id || data.manufacturer_id || null);
    } else {
      form.resetFields();
      setManufacturerId(null);
    }

  }, [data, form])



  const handleFieldChange = (value, lang, type) => {
    const fieldValue = form.getFieldValue(`${lang}_${type}`);

    setValidationStatus(prevStatus => ({
      ...prevStatus,
      [type]: {
        ...prevStatus[type],
        [lang]: !!fieldValue,
      }
    }));
  };

  const onCreate = (values) => {
    
    const payload = values;

    setLoading(true);
    request({
      url: MAKE_URL(path, data),
      method: 'POST',
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    })
  };

  const handleCancel = () => {
    setValidationStatus({ name: {}, display_name: {} });
    hide();
  };

  return (
    <Modal
      open = {show}
      title = {`${data ? 'Update ' + sectionName : 'Create a New ' + sectionName}`}
      okText = "Ok"
      onCancel = {handleCancel}
      width={800}
      okButtonProps = {{
        form: 'create',
        htmlType: 'submit',
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        
        <Row gutter={[16, 0]}>
          
          <Col span={24} xs={12} sm={12} md={12}>
            <Form.Item
              name="manufacturer_id"
              label="Select Manufacturer"
              rules={[{ required: true, message: "Please select manufacturer" }]}
            >
              <VehicleManufacturerSelect
                value={manufacturerId}
                onChange={(val) => {
                  setManufacturerId(val);
                  form.setFieldsValue({ manufacturer_id: val, vehicle_id: null });
                }}
              />
            </Form.Item>
          </Col>

          <Col span={24} xs={12} sm={12} md={12}>
            <Form.Item
              name="vehicle_id"
              label="Select Vehicle"
              rules={[{ required: true, message: "Missing Vehicle Selection" }]}
            >
              <VehicleSelect
                manufacturerId={manufacturerId}
                value={form.getFieldValue("vehicle_id")}
                disabled={!manufacturerId}
                onChange={(val) => form.setFieldsValue({ vehicle_id: val })}
              />
            </Form.Item>
          </Col>

          <Col span={24} xs={12} sm={12} md={24}>
            <Tabs defaultActiveKey={languages[0].short}>
              {languages.map(lang => (
                <TabPane 
                  tab={
                    <span>
                      {lang.long}
                      {(
                        validationStatus.name[lang.short] === false ||
                        validationStatus.display_name[lang.short] === false
                      ) && <Badge dot color="red" className="ml-1" />}
                    </span>
                  }
                  key={lang.short}
                >
                  <Form.Item
                    label={`Name (${lang.long})`}
                    name={`${lang.short}_name`}
                    rules={[
                      ...(lang.short === 'en' ? [
                        { required: true, message: `Please enter the name in ${lang.long}!` }
                      ] : []),
                      { max: 100, message: "Name should not contain more than 100 characters!" },
                      { min: 1, message: "Name should contain at least 1 characters!" },
                    ]}
                    onChange={(e) => handleFieldChange(e.target.value, lang.short, 'name')}
                  >
                    <Input autoComplete="off" placeholder={`Enter name in ${lang.long}`} />
                  </Form.Item>

                  <Form.Item
                    label={`Display Name (${lang.long})`}
                    name={`${lang.short}_display_name`}
                    rules={[
                      ...(lang.short === 'en' ? [
                        { required: true, message: `Please enter the display name in ${lang.long}!` }
                      ] : []),
                      { max: 100, message: "Display name should not contain more than 100 characters!" },
                      { min: 1, message: "Display name should contain at least 1 characters!" },
                    ]}
                    onChange={(e) => handleFieldChange(e.target.value, lang.short, 'display_name')}
                  >
                    <Input autoComplete="off" placeholder={`Enter display name in ${lang.long}`} />
                  </Form.Item>
                </TabPane>
              ))}
            </Tabs>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
};

export default From;